import customPossibleTypes from './customPossibleTypes';
import result from './introspectionResults';

export default {
  ...result.possibleTypes,
  ...customPossibleTypes,
  ReportDelta: ['ReportAbsoluteDelta', 'ReportNoComparison', 'ReportPercentDelta', 'ReportPointsDelta'],
  ReportTableCell: [
    'ReportTableBadgeCell',
    'ReportTableNoValueCell',
    'ReportTableTextCell',
    'ReportTableUrlCell',
    'ReportTableValueCell',
  ],
  ReportValue: [
    'ReportCount',
    'ReportDecimal',
    'ReportDuration',
    'ReportMoney',
    'ReportNoValue',
    'ReportPosition',
    'ReportPercentage',
  ],
  WebsiteAnalyticsReport: [
    'WebsiteAnalyticsMetricReport',
    'WebsiteAnalyticsSeriesReport',
    'WebsiteAnalyticsBreakdownReport',
    'WebsiteAnalyticsTableReport',
  ],
};
